'use strict';

var NavVisibility = require('./lib/nav-visibility');
var NavCollapse = require('./lib/nav-collapse');
var PanelGroups = require('./lib/panel-groups');
var PanelNav = require('./lib/panel-nav');

// Constructor
var Chronology = function() {
  var self = this;

  self.config = {
    'nav'                       :  '.chronology__nav',
    'navId'                     :  '#chronologyNav',
    'navToggle'                 :  '.chronology__nav-toggle',
    'navList'                   :  '.chronology__nav-list',
    'navListGroup'              :  '.chronology__nav-list-group',
    'navListGroupToggle'        :  '.chronology__nav-list-group-toggle',
    'navInnerList'              :  '.chronology__nav-inner-list',
    'navInnerLink'              :  '.chronology__nav-inner-link',
    'panelGroupToggle'          :  '[data-chronology-panel-group]',
    'panelGroup'                :  '.chronology__panel-group',
    'panelGroupPrevNextButton'  :  '.chronology__panel-group-prev-next-button',
    'panelNavButton'            :  '.chronology__panel-nav-button'
  }

  self.init = function() {
    new NavVisibility(self.config).init();
    new NavCollapse(self.config).init();
    new PanelGroups(self.config).init();
    new PanelNav(self.config).init();
  }
};

module.exports = Chronology;
